export type ElementPrefix = 'block-creator' | 'block-menu';

export const getElementId = (element: ElementPrefix, id: string) => {
  const map: Record<ElementPrefix, string> = {
    'block-creator': `block-creator:${id}`,
    'block-menu': `block-menu:${id}`,
  };
  return map[element];
};
